import React from "react";
import ListingLoader from "../../../component/LoaderTemplate";
import NoDataFound from "../../../component/NoDataFound";
import { STATUS } from "../../../constant";
import { isValidArray } from "../../../helper";
import { SelectIssueTemplate } from "../../../component/LoadersTemplate";
import SelectProjectSingle from "./SelectProjectSinglePage";

export default ({
  projects,
  isLoading,
  selectionHandler,
  ProjectSelected,
  selectAll,
  selectedProjects
}) => {
  console.log("projects", projects, selectedProjects);
  return (
    <div>
      {isLoading === STATUS.LOADING ? (
        <ListingLoader
          times={10}
          height={100}
          children={<SelectIssueTemplate />}
        />
      ) : isValidArray(projects) ? (
        (projects || []).map((project, index) => {
          // const projectSelected = selectedProjects.some(
          //   selectedProject => selectedProject.id === project.id
          // );

          return (
            <SelectProjectSingle
              project={project}
              idx={index}
              key={index}
              selectionHandler={selectionHandler}
              selectAll={selectAll}
              ProjectSelected={ProjectSelected}
              // projectSelected={projectSelected}
            />
          );
        })
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};
